import { FormEvent } from 'react'
import { FormEventHandler } from 'react'
import { Me } from '../../shared/types'
import { useMeGet, useMeUpdate } from '../api/me'
import { Button } from '../components/button'
import { Input } from '../components/input'

export function MySettings() {
	const { data, isSuccess, dataUpdatedAt } = useMeGet()
	const { mutate, isPending } = useMeUpdate()

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form))
	}

	if (!isSuccess) return null

	return (
		<MySettingsForm key={dataUpdatedAt} onSubmit={onSubmit} isPending={isPending} data={data} />
	)
}

type Props = {
	data?: Me
	onSubmit: FormEventHandler
	isPending?: boolean
}

export function MySettingsForm({ data, onSubmit, isPending }: Props) {
	return (
		<form className="bg-white rounded-xl border border-slate-200" onSubmit={onSubmit}>
			<div className="flex items-center justify-between gap-4 px-3 py-3 sm:px-5 sm:py-4">
				<h3 className="text-md font-bold">Osobní nastavení</h3>
			</div>
			<div className="px-3 py-3 sm:px-5 sm:py-4 space-y-4">
				<div className="grid grid-cols-2 gap-4">
					<Input label="Jméno" name="given_name" defaultValue={data?.given_name ?? ''} />
					<Input
						label="Příjmení"
						name="family_name"
						defaultValue={data?.family_name ?? ''}
					/>
					<Input
						className="col-span-2"
						label="Pozice"
						name="position"
						defaultValue={data?.position ?? ''}
					/>
				</div>
				<Button type="submit" isPending={isPending} isDisabled={isPending}>
					Uložit
				</Button>
			</div>
		</form>
	)
}
